"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var SilentLoginCallback = function (props) {
    var location = react_router_dom_1.useLocation();
    var authService = props.authService;
    react_1.useEffect(function () {
        authService.signinSilentCallback(location.hash);
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.default = SilentLoginCallback;
//# sourceMappingURL=SilentLoginCallback.js.map